import { Input } from '@angular/core';
import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BObjectModel, InputModel, QResult, QueovalBase, QueovalItem, QueovalParam } from '../../../../models';
import { Cursus, CursusModel } from '../../../../models/formation/cursus';
import { CoreService, HttpService } from '../../../../services';
import { ToastService } from '../../../../toast';

@Component({
  selector: 'q-comp-cursus-duplicate',
  templateUrl: './cursus-duplicate.component.html',
  styleUrls: ['./cursus-duplicate.component.css']
})
export class CursusDuplicateComponent {

  constructor(
    private modalService: NgbModal,
    private toast: ToastService,
    private http: HttpService,
    private indParam: CoreService,
  ) { }

  public boModel: BObjectModel;

  @ViewChild('modal') modal: ElementRef;
  modalRef: any;

  @Output() onModalClose = new EventEmitter<any>();
  idCursus: string;

  public listStageForCursus: Array<QueovalItem>;
  public isSaving: boolean = false;

  public withTrainer: boolean;
  public withResp: boolean;
  public withLocation: boolean;
  public withReserv: boolean;
  public withTache: boolean;

  public saveBO: boolean = false;

  public openModal(idCursus: string) {
    this.idCursus = idCursus;
    // Récupération des valeurs pour le BO
    this.getDataCursus();

    // Récupération des valeurs pour le BO
    this.getListStageForCursus();

    this.modalRef = this.modalService.open(this.modal, { size: 'q-xxl', centered: true, scrollable: true, windowClass: 'qmodalover' }).result.then((result) => {
    }, (reason) => {
      this.onModalClose.emit();
    });
  }

  private getListStageForCursus(): void {
    this.http.getHttp<QResult<Array<QueovalItem>>>(`${this.indParam.AppParams.apiUrl}api/Pipe/Formation/Cursus/GET_STAGES_FOR_CURSUS/${this.idCursus}`).subscribe((result: QResult<Array<QueovalItem>>) => {
      this.listStageForCursus = result.Value;
    });
  }

  private getDataCursus(): void {
    this.http.getHttp<QResult<Array<InputModel>>>(`${this.indParam.AppParams.apiUrl}api/Pipe/Formation/Cursus/GET_VALUES_FOR_DUPLICATE_CURSUS/${this.idCursus}`).subscribe((result: QResult<Array<InputModel>>) => {
      this.boModel = new BObjectModel();
      this.boModel.IdDonneeFils = '0';
      this.boModel.IdDonneePere = '1348';
      this.boModel.IdentBO = 'BO_CYCLE';
      this.boModel.IdRelation = 'REL_BO_CENT_BO_CYCLE';
      this.boModel.ShowSaveButton = false;
      this.boModel.DefaultInputs = result.Value;
    });
  }


  public onSaveBo(): void {
    if (this.isSaving) {
      this.toast.showInfoToast('Duplication du cursus en cours');
      return;
    }
    this.isSaving = true;
    this.boModel.IdDonneeFils = '0';
    this.saveBO = true;
  }

  public onBoSaved(newBo: BObjectModel): void {
    // Création du modèle pour la duplication du cursus
    let modelDuplication = new CursusModel();
    modelDuplication.Cursus = new Cursus();
    modelDuplication.Cursus.Ident = newBo.IdDonneeFils;
    modelDuplication.IdCursusToDuplicate = this.idCursus;
    modelDuplication.WithLocation = this.withLocation;
    modelDuplication.WithTrainer = this.withTrainer;
    modelDuplication.WithResp = this.withResp;
    modelDuplication.WithReserv = this.withReserv;
    modelDuplication.WithTache = this.withTache;
    modelDuplication.ListStages = this.listStageForCursus;

    this.http.postHttp<QueovalBase>(`${this.indParam.AppParams.apiUrl}api/Pipe/Formation/CursusModel/DUPLICATE_CURSUS`, modelDuplication).subscribe((result: QueovalBase) => {
      if (!result.HasError) {
        this.isSaving = false;
        this.saveBO = false;
        this.toast.showSuccessToast('Cursus dupliqué avec succès');
        this.modalRef.close();
        this.onModalClose.emit();
      }
    });
  }
}
